import i18n from '@/i18n';

const configModalCopyForm = {
    title: '',
    model: false,
    scrollable: true,
    hideFooter: false,
    validate: true,
    class: 'h-75',
    size: 'lg'
};

const initFormCopy = () => {
    return {
        campaign: null,
        client: null,
        name: null,
        url_public: null
    };
};

const configScreenCopy = () => {
    return {
        configFieldSelectCampaign: {
            trackBy: 'id',
            label: 'name',
            errorField: i18n.t('pageReturnPrize.nameCampaign'),
            valueSync: null,
            loading: false,
            error: false,
            isRemove: false,
            isRequired: false,
            typesValidate: []
        },
        configFieldNameForm: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingBasic.nameForm'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['required', 'max255']
        },
        configFieldPublicPath: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingBasic.publicPath'),
            errorCustomMess: '',
            valueSync: '',
            length: 60,
            typesValidate: ['required', 'maxCustom', 'sub-domain']
        }
    };
};

export { configModalCopyForm, initFormCopy, configScreenCopy };
